import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getEgonRoutesListFetchFailure, getEgonRoutesListFetchSuccess } from './reducer';
import { EgonRouteApiType, EgonRouteType, mapEgonRoute } from 'src/types/egonRoute';

const getEgonRoutesListFetchRequest = async (): Promise<EgonRouteType[]> => {
    const res = await api<{ data: EgonRouteApiType[] }>('get', 'api/secure/egon-routes');
    return (res.data.data || []).map(mapEgonRoute);
};

function* getEgonRoutesListFetch() {
    try {
        const response: EgonRouteType[] = yield call(getEgonRoutesListFetchRequest);
        yield put(getEgonRoutesListFetchSuccess(response));
    } catch (error) {
        yield put(getEgonRoutesListFetchFailure());
    }
}

export function* getEgonRoutesListFetchWatch() {
    yield takeEvery('egonRoutesList/getEgonRoutesListFetch', getEgonRoutesListFetch);
}
